import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import appVersion from '../../../package.json';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { AvatarModule } from 'primeng/avatar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-header',
  imports: [AvatarModule, AvatarGroupModule, SplitButtonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: true,
})
export class HeaderComponent implements OnInit {
  public version: string = appVersion.version;
  public profileMenu: MenuItem[] = [];

  constructor(public userService: UserService) {}

  ngOnInit(): void {
    this.profileMenu.push({
      label: `Welcome, ${this.userService.userProfile.firstName} ${this.userService.userProfile.lastName}`,
    });
    if (this.userService.userProfile.isDealer) {
      this.profileMenu.push({
        label: `Account Number: ${this.userService.userProfile.accountNumber}`,
      });
    } else if (this.userService.userProfile.isSalesRep) {
      this.profileMenu.push({
        label: `Commision Code: ${this.userService.userProfile.commissionCode}`,
      });
    }
    this.profileMenu.push({
      label: `Company Code: ${this.userService.userProfile.companyCode}`,
    });
    this.profileMenu.push({
      label: `version: ${this.version}`,
    });
    this.profileMenu.push({ separator: true });
    this.profileMenu.push({
      label: 'Logout',
      command: () => {
        this.onLogoutButtonClick('logout');
      },
    });
  }

  public onLogoutButtonClick(args: any): void {
    this.userService.logout();
  }
}
